import { useAppSelector } from "app/hooks";
import { isJustSuperAdmin, isSuperUser } from "utils";

export const usePermissions = () => {
  const role = useAppSelector(
    (state) => (state.profile.accountDetails?.admin?.role ?? "") as AdminRole
  );

  return {
    canWrite: isSuperUser(role),
    isSuperAdmin: isJustSuperAdmin(role),
  };
};
